module.exports = __webpack_public_path__ + "static/media/dtb2.fcee4e70.png";